import Vue from 'vue'

// Local components
import Address from './src/components/Address'
import Alert from './src/components/Alert'
import Badge from './src/components/Badge'
import Boolean from './src/components/Boolean'
import Branding from './src/components/Branding'
import Button from './src/components/Button'
import Card from './src/components/Card'
import LineChart from './src/components/Charts/LineChart'
import PieChart from './src/components/Charts/PieChart'
import CardTransaction from './src/components/CardTransaction'
import Confirm from './src/components/Confirm'
import Datatable from './src/components/Datatable'
import DateRange from './src/components/Form/DateRange'
import Dropdown from './src/components/Dropdown'
import DropdownItem from './src/components/Dropdown/DropdownItem'
import Dropzone from './src/components/Dropzone'
import ErrorPage from './src/components/ErrorPage'
import Checkbox from './src/components/Form/Checkbox'
import Error from './src/components/Form/Error'
import Field from './src/components/Form/Field'
import FormRoot from './src/components/Form/Form'
import FormActions from './src/components/Form/FormActions'
import FormGroup from './src/components/Form/FormGroup'
import Input from './src/components/Form/Input'
import InputHint from './src/components/Form/InputHint'
import Radio from './src/components/Form/Radio'
import SelectAsync from './src/components/Form/SelectAsync'
import Submit from './src/components/Form/Submit'
import Tags from './src/components/Form/Tags'
import Textarea from './src/components/Form/Textarea'
import Icon from './src/components/Icons/Icon'
import ID from './src/components/ID'
import Layout from './src/components/Layout'
import LoaderFullscreen from './src/components/Loaders/LoaderFullscreen'
import LoaderHexeko from './src/components/Loaders/LoaderHexeko'
import Spinner from './src/components/Loaders/Spinner'
import LoginScreen from './src/components/LoginScreen'
import Logo from './src/components/Logo'
import Modal from './src/components/Modal'
import Pagination from './src/components/Pagination'
import Panel from './src/components/Panel'
import Progress from './src/components/Progress'
import Round from './src/components/Round'
import SelectLang from './src/components/SelectLang'
import Sheet from './src/components/Sheet'
import Row from './src/components/Sheet/Row'
import Stat from './src/components/Stat'
import Steps from './src/components/Steps'
import Table from './src/components/Table'
import Tabs from './src/components/Tabs'
import Tab from './src/components/Tabs/Tab'
import Tag from './src/components/Tag'
import ToggleSwitch from './src/components/ToggleSwitch'
import ToggleCheckbox from './src/components/ToggleCheckbox'
import TransactionalScreen from './src/components/TransactionalScreen'

// Local scripts
import Alerts from './src/scripts/Alerts'
import Form from './src/scripts/Form'

// Bootstrap
import 'bootstrap';

// Numeral Filter
import vueNumeralFilterInstaller from 'vue-numeral-filter'

// Clipboard
import VueClipboard from 'vue-clipboard2'

// Tooltip
import VTooltip from 'v-tooltip'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)
library.add(far)

// i18n (localization)
import VueI18n from 'vue-i18n'
import LangLines from './src/lang'

// Vue configuration
import VueConfig from 'vue-configuration';

// Filters
import './src/filters'

// Directives
import './src/directives'

// Default options
const defaultOptions = {
    displayLanguage: 'en',
    availableLanguages: ['en', 'nl', 'fr'],
    api: null,
    reset_password_url: null
}

export {
    // Components
    Address,
    Alert,
    Badge,
    Boolean,
    Button,
    Card,
    LineChart,
    PieChart,
    CardTransaction,
    Confirm,
    Datatable,
    DateRange,
    Dropdown,
    DropdownItem,
    Dropzone,
    ErrorPage,
    Checkbox,
    Error,
    Field,
    FormRoot,
    FormActions,
    FormGroup,
    Input,
    InputHint,
    Radio,
    SelectAsync,
    Submit,
    Tags,
    Textarea,
    Icon,
    ID,
    Layout,
    LoaderFullscreen,
    LoaderHexeko,
    Spinner,
    LoginScreen,
    Logo,
    Modal,
    Pagination,
    Panel,
    Progress,
    Round,
    SelectLang,
    Sheet,
    Row,
    Stat,
    Steps,
    Table,
    Tabs,
    Tab,
    Tag,
    ToggleSwitch,
    ToggleCheckbox,
    TransactionalScreen,

    // Scripts
    Alerts,
    Form
};

export default {

    install(Vue, userOptions) {

        // Set config
        let options = {...defaultOptions, ...userOptions};
        this.setConfig(options)

        // Packages
        Vue.component('font-awesome-icon', FontAwesomeIcon)

        // Auto-loaded components
        Vue.component('Confirm', Confirm);
        Vue.component('Icon', Icon);

    },

    setConfig(options) {

        // Store config
        Vue.use(VueConfig, {
            config: options
        });

        // Vue Numeral Filter
        Vue.use(vueNumeralFilterInstaller, { locale: 'fr' });

        // Clipboard
        Vue.use(VueClipboard)

        // Tooltip
        Vue.use(VTooltip)

        // i18n
        Vue.use(VueI18n)
        let i18n = new VueI18n({
            locale: options.displayLanguage,
            messages: LangLines
        })
        Vue.prototype._i18n = i18n

        // API
        if (options.api) {
            Vue.prototype.$api = options.api
        }

    }

};